import type { FeatureFlagObject } from "~/account/types/feature-flags";

export const getFeatureFlags = async (options?: { ignoreFallback?: boolean }) => {
  const theme = useTheming();
  const runtimeConfig = useRuntimeConfig();

  const appFeatureFlags = await $fetch<FeatureFlagObject>(theme.featureFlagsJSONPath, {
    baseURL: runtimeConfig.public.contentBaseUrl,
    cache: "no-cache",
  }).catch(() => null);

  if (!appFeatureFlags && !options?.ignoreFallback) {
    const fallbackFeatureFlags = await $fetch<FeatureFlagObject>(theme.fallbackFeatureFlagsJSONPath, {
      baseURL: runtimeConfig.public.contentBaseUrl,
      cache: "no-cache",
    }).catch(() => null);

    return fallbackFeatureFlags;
  }

  return appFeatureFlags;
};

export const updateFeatureFlags = async (featuresBody: FeatureFlagObject) => {
  const theme = useTheming();

  await useAPI("api/v1/internal/features/flags", {
    method: "PUT",
    query: {
      tenantName: theme.appName,
    },
    body: JSON.stringify(featuresBody),
  });
};

export const getCachedFeatureFlags = useMemoize(getFeatureFlags);
